<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { getTokenInURL } from './public/api/backend'

export default {
  name: 'App',
  data() {
    return {

    };
  },
  created() {
    this.checkCurrentLogin()
  },
  updated() {
    this.checkCurrentLogin()
  },
  methods: {

    checkCurrentLogin() {
      const validRoutes = [
        'Login',
        'Resetpassword',
        'Forgotpassword',
        'NewAccountant',
        'customException',
        'invalidDocument'
      ];

      if (
        !localStorage.getItem('access_token')
         && !validRoutes.includes(this.$route.name)
         && !getTokenInURL(this.$route.fullPath)
      ) {
        this.$router.push('/')
        this.$toasted.show('Falha ao acessar, você precisar estar logado.', {
          theme: 'outline',
          position: 'bottom-right',
          duration: 5000,
          type: 'error',
          icon: 'error_outline'
        });
      }
    }
  }
};
</script>

<style>

@import "./client/public/css/dashboard.css";
@import "./client/public/css/footer.css";
@import "./client/public/css/notas.css";
@import "./client/public/css/perfil.css";
@import "./client/public/css/sped.css";
@import "./accountant/public/css/dashboard.css";
@import "./accountant/public/css/requests.css";
@import "./accountant/public/css/documents.css";
@import "./client/public/css/requestsClient.css";
#app {
  font-family: Lato,sans-serif;
  font-size: 14px;
  font-weight: 600;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #7e7e7e;
  background-color: #ededed;
  -webkit-font-smoothing: antialiased;
  color: #7e7e7e;
  line-height: 1.42857143;
  letter-spacing: .5px;
}
#body {
    margin: 0;
    font-family: -apple-system,
      BlinkMacSystemFont,
      Roboto,
      Arial,
      sans-serif,
      "Segoe UI",
      "Noto Sans",
      "Segoe UI Emoji",
      "Helvetica Neue",
      "Segoe UI Symbol",
      "Noto Color Emoji",
      "Apple Color Emoji";
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    text-align: left;
    background-color: rgb(236, 236, 236)!important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue